module.exports = __webpack_public_path__ + "static/media/team-tim.079412c1.jpg";